import { render, staticRenderFns } from "./studentClassList.vue?vue&type=template&id=77660cdf&scoped=true&"
import script from "./studentClassList.vue?vue&type=script&lang=js&"
export * from "./studentClassList.vue?vue&type=script&lang=js&"
import style0 from "./studentClassList.vue?vue&type=style&index=0&id=77660cdf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77660cdf",
  null
  
)

export default component.exports